"use strict";

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WithQuery = /*#__PURE__*/function () {
  function WithQuery(query) {
    _classCallCheck(this, WithQuery);

    this.currentQuery = null;
    this.currentQuery = query;
  }

  _createClass(WithQuery, [{
    key: "query",
    get: function get() {
      if (!this.currentQuery) {
        throw new Error('undefined query');
      }

      return this.currentQuery;
    },
    set: function set(query) {
      this.currentQuery = query;
    }
  }]);

  return WithQuery;
}();

exports.WithQuery = WithQuery;